import React from "react";

const RegisterContent = () => {
  return <div>RegisterContent</div>;
};

export default RegisterContent;
